import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { RequestBuilder } from '../classes/request-builder';
import { Observable } from 'rxjs';
import * as Enum from '../utils/enums';

@Injectable()
export class MezziService extends BaseService {

  constructor(http: Http) {
    super(http)
  }

  /**
   * termina attivita per mezzo
   * @param reqBuilder 
   */
  terminaAttivita(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('mezzo/terminaAttivita', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * Modifica del 26/11/2024 - Nuovo servizio di delete Mezzo
   * Delete MEZZO
   * @param reqBuilder 
   */
  delete(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('mezzo/delete', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
  * Save MEZZO
  * @param reqBuilder 
  */
  save(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('mezzo/save', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * update MEZZO
   * @param reqBuilder 
   */
  update(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('mezzo/update', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * Get list of mezzi
   * @param reqBuilder 
   */
  getAllMezzi(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('mezzo/fetch', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * report mezzi validati
   * @param reqBuilder 
   * @returns response for download
   */
  reportMezziValidati(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('mezzo/ReportValidati', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * report mezzi censiti
   * @param reqBuilder 
   * @returns response for download
   */
   reportMezziCensiti(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('mezzo/ReportCensiti', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

}